export default __webpack_public_path__ + "static/social_media_banner-7ea3afe2575692f2e033f049ad05a260.webp";